import { useContext, createContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import PanoramicConfigType from './typings';
import Config from './config';
const Context = createContext({});

export const useInitConfig = () => {
  const mobxStore = useContext(MobXProviderContext);
  const { app, auth, area, product } = mobxStore;
  const {
    productDetail: { id: pid, productMainVideoVoList },
    curSelectCommodityId: cid,
    curSelectCommodity: { commodityName },
  } = product;
  const { isMobile } = app;
  const { LANG } = area;
  const configData: PanoramicConfigType = {
    mobxStore: {
      app,
      auth,
      area,
      product,
    },
    isProductStandardCid: Config.isProductStandardCid(pid, cid),
    fourviewConfig: Config.getFourviewConfig(pid, isMobile),
    sceneviewConfig: Config.getSceneviewConfig(pid, cid, isMobile),
    commodityAccessoryList: Config.getCommodityAccessoryList(cid, commodityName, isMobile, LANG, pid),
    panoramicVideo: Config.getPanoramicVideo(pid, cid),
    SPECIAL_COMMODITY: Config.SPECIAL_COMMODITY,
    masterVideoList: Config.getMasterVideo(productMainVideoVoList, cid),
    skipIndex: null,
  };
  return configData;
};

export const useGetConfig = (): PanoramicConfigType => {
  const _data = useContext(Context);
  return _data as PanoramicConfigType;
};

export const ConfigProvider = Context.Provider;
